module.exports = __webpack_public_path__ + "static/sport/bgi-pc.679e88e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/bgi-pc.jpg
// module id = mill
// module chunks = 0